import { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Calendar, Music, User, Utensils, MapPin, ArrowRight, Clock } from 'lucide-react';
import { LucideIcon } from 'lucide-react';

interface Event {
  id: number;
  title: string;
  date: string;
  time: string;
  description: string;
  imageSrc: string;
  category: string;
  icon: LucideIcon;
  location?: string;
}

const EventsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const upcomingEvents: Event[] = [
    {
      id: 1,
      title: 'Večer žive glasbe',
      date: '15. junij 2023',
      time: '20:00',
      description: 'Lokalni glasbenik bo ustvaril prijetno vzdušje ob koncu tedna. Pridružite se nam na večerji z živo spremljavo.',
      imageSrc: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Glasba',
      icon: Music,
      location: 'Notranja dvorana'
    },
    {
      id: 2,
      title: 'Degustacija craft piv',
      date: '22. junij 2023',
      time: '18:00',
      description: 'Spoznajte različna lokalna craft piva z našim strokovnjakom. V ceno vstopnice je vključena degustacija 5 različnih vrst piva.',
      imageSrc: 'https://images.unsplash.com/photo-1535359056830-d4badde79747?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Degustacija',
      icon: Utensils,
      location: 'Bar'
    },
    {
      id: 3,
      title: 'Tematski večer: Balkanski žar',
      date: '29. junij 2023',
      time: '19:00',
      description: 'Posebna ponudba balkanskih specialitet z žara in tradicionalna glasba. Doživite pristne okuse Balkana v srcu Štajerske.',
      imageSrc: 'https://images.unsplash.com/photo-1544025162-d76694265947?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Tematski večer',
      icon: Utensils,
      location: 'Celoten lokal'
    },
    {
      id: 4,
      title: 'Vinska zgodba: Slovenski vinogradi',
      date: '6. julij 2023',
      time: '19:30',
      description: 'Spoznajte različne slovenske vinorodne okoliše in njihove značilne sorte. Vključena degustacija 6 vrhunskih vin s prigrizki.',
      imageSrc: 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Degustacija',
      icon: Utensils,
      location: 'Vinska klet'
    },
    {
      id: 5,
      title: 'Nastop akustične skupine',
      date: '13. julij 2023',
      time: '21:00',
      description: 'Večer z lokalnimi glasbeniki, ki bodo izvajali priredbe popularnih pesmi in avtorsko glasbo.',
      imageSrc: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Glasba',
      icon: Music,
      location: 'Poletna terasa'
    },
    {
      id: 6,
      title: 'Kuharska delavnica: Skrivnosti žara',
      date: '20. julij 2023',
      time: '17:00',
      description: 'Naučite se skrivnosti priprave popolnih jedi z žara pod vodstvom našega kuharja. Število mest je omejeno.',
      imageSrc: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Delavnica',
      icon: Utensils,
      location: 'Letni vrt'
    },
  ];

  const pastEvents: Event[] = [
    {
      id: 101,
      title: 'Velikonočni brunch',
      date: '9. april 2023',
      time: '11:00',
      description: 'Praznični brunch s tradicionalnimi velikonočnimi jedmi in posebno ponudbo za družine.',
      imageSrc: 'https://images.unsplash.com/photo-1563208085-648526fc0a70?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Praznik',
      icon: Utensils,
    },
    {
      id: 102,
      title: 'Predstavitev lokalnih vinarjev',
      date: '25. marec 2023',
      time: '18:30',
      description: 'Spoznavanje okoliških vinarjev in njihovih posebnih vin z možnostjo nakupa.',
      imageSrc: 'https://images.unsplash.com/photo-1567590997610-cca4b1fd9027?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Degustacija',
      icon: Utensils,
    },
    {
      id: 103,
      title: 'Jazz večer',
      date: '18. februar 2023',
      time: '20:00',
      description: 'Večer ob zvokih klasičnega in modernega jazza z lokalnimi glasbeniki.',
      imageSrc: 'https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      category: 'Glasba',
      icon: Music,
    },
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      
      {/* Hero Banner */}
      <section className="relative pt-20 h-[40vh] min-h-[300px] flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1470337458703-46ad1756a187?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
            alt="Dogodki - Žar & Bar"
            className="w-full h-full object-cover"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="container mx-auto px-4 md:px-8 z-10 animate-fade-in">
          <h1 className="heading-xl text-white text-center">Dogodki</h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-12 animate-fade-in">
          <h2 className="heading-lg mb-4">Prihajajoči dogodki</h2>
          <p className="paragraph">
            Pridružite se nam na posebnih večerih z živo glasbo, degustacijah in tematskih dogodkih.
            Vedno se pri nas nekaj dogaja!
          </p>
        </div>

        {/* Calendar View */}
        <div className="mb-16">
          <div className="bg-white rounded-xl shadow-md p-8 overflow-hidden animate-fade-in">
            <h3 className="heading-md mb-6 flex items-center">
              <Calendar className="mr-2 text-barbecue-600" />
              Junij - Julij 2023
            </h3>
            
            <div className="space-y-6">
              {upcomingEvents.map((event) => (
                <div key={event.id} className="flex flex-col md:flex-row items-start gap-6 p-4 border-b border-earth-200 last:border-0 hover:bg-earth-50 transition-colors rounded-lg">
                  <div className="md:w-1/4 lg:w-1/5">
                    <img 
                      src={event.imageSrc} 
                      alt={event.title} 
                      className="w-full h-48 object-cover rounded-lg shadow-md" 
                    />
                  </div>
                  <div className="md:w-3/4 lg:w-4/5">
                    <div className="flex flex-wrap items-center gap-3 mb-2">
                      <span className="bg-barbecue-100 text-barbecue-800 px-3 py-1 rounded-full text-sm font-medium">
                        {event.category}
                      </span>
                      <span className="flex items-center text-foreground/70 text-sm">
                        <Calendar className="w-4 h-4 mr-1" />
                        {event.date}
                      </span>
                      <span className="flex items-center text-foreground/70 text-sm">
                        <Clock className="w-4 h-4 mr-1" />
                        {event.time}
                      </span>
                      {event.location && (
                        <span className="flex items-center text-foreground/70 text-sm">
                          <MapPin className="w-4 h-4 mr-1" />
                          {event.location}
                        </span>
                      )}
                    </div>
                    <h3 className="heading-sm mb-2">{event.title}</h3>
                    <p className="paragraph mb-4">{event.description}</p>
                    <button className="btn-outline !px-4 !py-2 !text-sm inline-flex items-center">
                      Rezerviraj mesto
                      <ArrowRight className="ml-2 w-4 h-4" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Private Events Section */}
        <div className="glass-card p-8 md:p-12 animate-fade-in mb-16">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-2/3 md:pr-8 mb-6 md:mb-0">
              <h3 className="heading-md mb-4">Organizirajte vaš zasebni dogodek pri nas</h3>
              <p className="paragraph mb-6">
                Praznujte rojstni dan, obletnico ali poslovni uspeh v našem prijetnem ambientu.
                Pripravimo meni po vaših željah in poskrbimo za nepozabno doživetje.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                <div className="flex items-center">
                  <User className="w-5 h-5 text-barbecue-500 mr-2" />
                  <span className="text-sm">Do 50 oseb</span>
                </div>
                <div className="flex items-center">
                  <Utensils className="w-5 h-5 text-barbecue-500 mr-2" />
                  <span className="text-sm">Po meri prilagojen meni</span>
                </div>
                <div className="flex items-center">
                  <Music className="w-5 h-5 text-barbecue-500 mr-2" />
                  <span className="text-sm">Možnost glasbe</span>
                </div>
              </div>
              <a href="/contact" className="btn-secondary">
                Pošljite povpraševanje
              </a>
            </div>
            <div className="md:w-1/3">
              <img 
                src="https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Zasebni dogodek" 
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>

        {/* Past Events */}
        <div className="animate-fade-in">
          <h3 className="heading-md mb-8 text-center">Pretekli dogodki</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {pastEvents.map((event) => (
              <div key={event.id} className="card overflow-hidden">
                <div className="relative h-48">
                  <img 
                    src={event.imageSrc} 
                    alt={event.title} 
                    className="w-full h-full object-cover" 
                  />
                  <div className="absolute top-4 right-4 bg-barbecue-600 text-white text-xs font-medium px-3 py-1 rounded-full">
                    {event.category}
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <Calendar className="w-5 h-5 text-barbecue-500 mr-2" />
                    <span className="text-sm text-foreground/70">{event.date} ob {event.time}</span>
                  </div>
                  <h3 className="heading-sm mb-2">{event.title}</h3>
                  <p className="text-foreground/80 line-clamp-2 mb-4">{event.description}</p>
                  <button className="text-barbecue-600 font-medium hover:text-barbecue-800 transition-colors">
                    Poglej galerijo
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="mt-16 bg-earth-50 rounded-xl p-8 animate-fade-in">
          <div className="max-w-xl mx-auto text-center">
            <h3 className="heading-md mb-4">Ostanite obveščeni o dogodkih</h3>
            <p className="paragraph mb-6">
              Prijavite se na naše e-novice in bodite med prvimi obveščeni o 
              prihajajočih dogodkih, posebnih ponudbah in novostih.
            </p>
            <form className="flex flex-col sm:flex-row gap-3">
              <input 
                type="email" 
                placeholder="Vaš e-mail naslov" 
                className="flex-grow contact-input"
                required
              />
              <button type="submit" className="btn-primary whitespace-nowrap">
                Prijavite se
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EventsPage;